<template>
  <v-app>
    <v-content>

      <Calendar/>

    </v-content>
  </v-app>
</template>
<script> import Calendar from './components/Calendar.vue'

export default {
  name: 'App',
  components: {
    Calendar
  }
}
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.theme--light.v-application{
  background-color: transparent !important;;
}
.v-application--wrap{
  min-height: 500px !important;
  margin: 0 0 15px 0;
}
</style>
